import React from "react";
import { PERIODS } from "../../content/index.content";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../../../helpers";
import TitleTab from "./TitleTab";
import Mark from "./Mark";
import Info from "./Info";
import "./index.scss";

const Tab = ({ tab, diIndex, period }) => {
  return (
    <ul className="GP-C-T-T">
      {tab.map(({ title, tariffs: { mark, info } }, i) => (
        <li
          key={i}
          className={getTrueClasses(
            "GP-C-T-T-I",
            `GP-C-T-T-I_di${diIndex + 1}_ti${i + 1}`
          )}
        >
          <TitleTab {...title} period={period} />
          <ul className="GP-C-T-T-tr">
            {PERIODS.map((tdPeriod) => {
              const currentMark =
                mark && (typeof mark === "string" ? mark : mark[tdPeriod]);
              return (
                <li key={tdPeriod} className="GP-C-T-T-tr-td">
                  {mark && (
                    <Mark
                      mark={currentMark || ""}
                      customClass="GP-C-T-T-tr-td__mark"
                    />
                  )}
                  {info && <Info {...info[tdPeriod]} />}
                </li>
              );
            })}
          </ul>
        </li>
      ))}
    </ul>
  );
};
Tab.propTypes = {
  tab: PropTypes.array,
  diIndex: PropTypes.number,
  period: PropTypes.string,
};
export default Tab;
